/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Weighing_Filter_UnapprovedInputs */

const vi_weighing_filter_unapproved = /** @type {(inputs: Weighing_Filter_UnapprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa duyệt`)
};

/**

* @param {Weighing_Filter_UnapprovedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const weighing_filter_unapproved = /** @type {((inputs?: Weighing_Filter_UnapprovedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weighing_Filter_UnapprovedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_weighing_filter_unapproved(inputs)
});